import React from "react"

export function PreviewNotice() {
  return (
    <div role="note" className="my-4 rounded-md border border-[#107D98] bg-[#107D98]/10 px-4 py-3 dark:bg-[#107D98]/20">
      <p className="font-semibold text-[#107D98] dark:text-[#4fc3dc]">You're viewing a preview</p>
      <p className="mt-1 text-sm text-foreground">
        The full document is available with a Specia subscription.
      </p>
    </div>
  )
}
